import React from "react";

import { ReactComponent as Checked } from "~/assets/images/dashboard/Checked.svg";
import { ReactComponent as Unchecked } from "~/assets/images/dashboard/Unchecked.svg";

import Loader from "~/components/loader"


const CheckMark = ({done})=> {

  return (
    <div className="m-r-20">
      {done === false && <Unchecked /> }
      {done === true  && <Checked  />}
      {done === null && <Loader type={19} size={20} /> }
    </div>
  );
}

export default CheckMark;
